module.exports = __webpack_public_path__ + "img/sLightnDrg_193x205.dcd897c1.png";